import { Spin } from "antd";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
// Uncomment next line if you want AntD Spinner
// import { Spin } from "antd";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 10px;
  font-family: Inter, sans-serif;
`;

const Text = styled.p`
  font-size: 1.1rem;
  margin-top: 20px;
  text-align: center;
  opacity: ${(props) => (props.fade ? 1 : 0)};
  transition: opacity 0.5s ease;
`;

const FullPageSpin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 80vh;
`;

const AnimatedLoader = ({
  fullPage = false,
  languageLoader = false,
  intervalSeconds = 3500,
}) => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const messages = [
    "Recaliberating workplace vibes...",
    "Rethinking what really matters...",
    "Sharper question loading…",
  ];

  const languagesMessages = [
    "Loading... becoming multilingual!",
    "Recomputing culturally aware translations...",
    "One moment... making sure this makes sense everywhere...",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // fade out

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length);
        setFade(true); // fade in
      }, 500);
    }, intervalSeconds);

    return () => clearInterval(interval);
  }, [intervalSeconds]);

  if (fullPage) {
    return (
      <FullPageSpin>
        <Spin tip="Loading..." size="large" />
        <Text fade={fade}>
          {languageLoader ? languagesMessages[index] : messages[index]}
        </Text>
      </FullPageSpin>
    );
  }

  return (
    <Container>
      {/* Native loader (use Spin from AntD if needed) */}
      <Spin tip="Loading..." size="large" />
      {/* Or use AntD: <Spin size="large" /> */}

      <Text fade={fade}>
        {languageLoader ? languagesMessages[index] : messages[index]}
      </Text>
    </Container>
  );
};

export default AnimatedLoader;
